// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3qSa4","ScrollX":"Scroll_ScrollX__1vqfP","ScrollY":"Scroll_ScrollY__iuE9M"};